import { ButtonHTMLAttributes } from 'react';
import { DefaultTheme } from 'styled-components';

export enum ButtonVariantsEnum {
  Primary = 'primary',
  Secondary = 'secondary',
  SecondaryWhite = 'secondaryWhite',
  Outlined = 'outlined',
  TextLink = 'textLink',
  Select = 'select',
  OutlinedWithoutBackground = 'outlinedWithoutBackground',
}

export type ButtonVariants =
  | 'primary'
  | 'secondary'
  | 'secondaryWhite'
  | 'outlined'
  | 'textLink'
  | 'select'
  | 'outlinedWithoutBackground';

export type ButtonSizeType = 'regular' | 'small' | 'extraSmall';
export type ThemePalette = DefaultTheme['palette'];
export type ButtonThemePalette = Pick<ThemePalette, 'button'>;
export type BrandThemePalette = Pick<ThemePalette, 'brand'>;

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: JSX.Element | string | React.ReactNode;
  typeStyle?: ButtonVariantsEnum | ButtonVariants;
  size?: ButtonSizeType;
  disabled?: boolean;
  sticky?: boolean;
  blockMode?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  noMinWidth?: true;
  loader?: boolean;
  loaderDesc?: string;
  isFocused?: boolean;
}

export interface ClickPosition {
  left: string;
  top: string;
  diameter: number;
}
